









































import Vue, { PropType } from 'vue'
import Icon from '@/ui/icon/Icon.vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import Divider from '@/ui/divider/Divider.vue'
import { navigatePush } from '@/features/navigation/navigationMethods'

export default Vue.extend({
  name: 'LearningHeader',
  components: {
    Icon,
    BaseButton,
    Divider,
  },
  props: {
    title: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: true },
  },
  methods: {
    goToList() {
      navigatePush({ name: 'courses-application-list' })
    },
  },
})
